export default "__VITE_ASSET__a8bb963b__"